import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subject, timer, Subscription } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import { AuthService } from '../../shared/auth/auth.service';
import { ModalOptions, BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SharedServicesService } from 'app/shared/sharedservices/shared-services.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { min } from 'moment';

@Component({
  selector: 'app-inactivity-timer',
  //template: ``,
  templateUrl: './inactivity-timer.component.html',
  styleUrls: ['./inactivity-timer.component.scss']
})
export class InactivityTimerComponent implements OnDestroy, OnInit {

  // set logoutAfterMinutes to 60 and showMsgAfterMinutes to 55.
  // TODO: FOR TESTING
  logoutAfterMinutes = 60;
  // TODO: FOR TESTING
  showMsgAfterMinutes = 55;
  logoutAfterMilliSeconds = +this.logoutAfterMinutes * 60 * 1000;
  showMsgAfterMilliSeconds = +this.showMsgAfterMinutes * 60 * 1000;
  refreshLoginTimeAfterMilliSeconds = 60 * 1000;  // 1 Minute

  minutesDisplay = 0;
  secondsDisplay = 0;

  modalDisplayed=false;
  modalOption: ModalOptions = {};
  modalRef: BsModalRef;
  @ViewChild('template1') template1: TemplateRef<any>;

  endTime = 1;

  unsubscribe$: Subject<void> = new Subject();
  timerSubscription: Subscription;

  constructor(private authService: AuthService,
    private modalService: BsModalService,
    public restService: SharedServicesService,
    private spinner: NgxSpinnerService) {
    
  }

  ngOnInit() {
    // TODO: FOR TESTING
    console.log('CALLED Init Inactivity-timer');
    this.resetTimer();
    this.authService.userActionOccured.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(() => {
      if(!this.modalDisplayed){
        this.resetTimer();
      }
    });
  }

  ngOnDestroy() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  stopTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  resetTimer(endTime: number = this.endTime) {   
    // TODO: FOR TESTING REMOVE
    //console.log('CALLED resetTimer() at datetime: '+JSON.stringify((new Date()).toString()));
    this.stopTimer();

    if (!sessionStorage.getItem("resource")) {
      // TODO: FOR TESTING
      console.log('RETURNING resetTimer() AS NOT FOUND "resource" in session');
      return;
    }
    
    this.refreshLoginTime();
    
    //const interval = 1000;
    const interval: number = 1000;
    // const tokenTimeDiff = (this.authService.tokenTimeDifference() - 5);
    // let duration = tokenTimeDiff * 60;

    //let duration = this.logoutAfterMinutes * 60;
    let duration: number = this.logoutAfterMilliSeconds / interval;

    // sessionStorage.setItem('resetInactivityTimerOn', (new Date()).toString());
    // let dueTime = new Date((new Date()).getTime() + interval); //0;
    let resetInactivityTimerOn = new Date();    
    // TODO: FOR TESTING REMOVE
    //console.log('resetInactivityTimerOn '+ resetInactivityTimerOn.toString());
    let dueTime = 0;//new Date(resetInactivityTimerOn.getTime() + interval);
    //this.timerSubscription = timer(0, interval).pipe(
    this.timerSubscription = timer(dueTime, interval).pipe(   //emits sequence of integers infinitely.
      take(duration)  //emit count when timer observable completes.
    ).subscribe(value => {      
      if(((new Date()).getTime() - resetInactivityTimerOn.getTime()) >= this.logoutAfterMilliSeconds){
        this.logoutForInactivity(); 
      }
      // TODO: FOR TESTING
      //console.log(JSON.stringify(value) +' value Timer emitted from resetTimer() at datetime: '+JSON.stringify((new Date()).toString()));
      //if(value > (this.showMsgAfterMinutes)*60) {
      if(((new Date()).getTime() - resetInactivityTimerOn.getTime()) >= this.showMsgAfterMilliSeconds) {
        //this.render((duration - +value) * interval);
        // TODO: FOR TESTING REMOVE
        //console.log('((new Date()).getTime() - resetInactivityTimerOn.getTime()) = '+ JSON.stringify(((new Date()).getTime() - resetInactivityTimerOn.getTime())));
        if((this.logoutAfterMilliSeconds - ((new Date()).getTime() - resetInactivityTimerOn.getTime()) -1) > 0)
          this.renderRemainingTime(this.logoutAfterMilliSeconds - ((new Date()).getTime() - resetInactivityTimerOn.getTime()) -1);
        else 
          this.renderRemainingTime(0);

        if(!this.modalDisplayed){
          console.log('Show popup from resetTimer() at datetime: '+JSON.stringify((new Date()).toString()));
          this.openModal();
        }
      }
     } ,
      err => { },
      // On Timer Completion Logout the user.
      () => {
       this.logoutForInactivity(); 
      }
    );
  }

  logoutForInactivity() {
    // TODO: FOR TESTING
    console.log('LoggingOut from resetTimer() at datetime: '+JSON.stringify((new Date()).toString()));
    if (sessionStorage.getItem("resource")) {
      this.spinner.show();
      this.stopTimer();
      //this.render(0);
      this.authService.logoutForInactivity();
      this.closeModal();
    }
  }

  refreshLoginTime() {
    if(sessionStorage.getItem('loginRefreshedOn') && !sessionStorage.getItem('InvokedRefreshLogin')) {      
      let lastRefreshedOn = new Date(sessionStorage.getItem('loginRefreshedOn'));
      
      if(((new Date()).getTime() - lastRefreshedOn.getTime())
        >= this.refreshLoginTimeAfterMilliSeconds) {
        this.restService.updateLoginRefreshTime().subscribe( res => {  
          sessionStorage.setItem('loginRefreshedOn', (new Date()).toString());
          sessionStorage.removeItem('InvokedRefreshLogin');
        });
      }
    }
  }
  
  openModal() {    
    if (!sessionStorage.getItem("resource")) {
      return;
    }
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalRef = this.modalService.show(this.template1, this.modalOption);
    //this.modalRef.setClass('ea-modal');
    this.modalDisplayed = true;
  }

  closeModal() {
    this.modalRef.hide();
    this.modalDisplayed = false;
    this.resetTimer();
  }

  confirmLogout(){
    this.spinner.show();
    this.stopTimer();
    this.authService.logout();
  }

  private render(count) {
    // TODO: FOR TESTING
    //console.log('From render(count) '+ JSON.stringify(count) +' at datetime: '+JSON.stringify((new Date()).toString()));
    this.secondsDisplay = this.getSeconds(count);
    this.minutesDisplay = this.getMinutes(count);
  }

  private renderRemainingTime(ms: number) {
    let seconds = ((ms % 60000) / 1000).toFixed(0);
    let minutes = Math.floor(ms / 60000);
    if(seconds === '60') {
      seconds = '0';
      minutes += 1;
    }
    this.secondsDisplay = this.pad(seconds);
    this.minutesDisplay = this.pad(minutes);
  }

  private getSeconds(ticks: number) {
    const seconds = ((ticks % 60000) / 1000).toFixed(0);
    return this.pad(seconds);
  }

  private getMinutes(ticks: number) {
    const minutes = Math.floor(ticks / 60000);
    return this.pad(minutes);
  }

  private pad(digit: any) {
    return digit <= 9 ? '0' + digit : digit;
  }
}
